import React from 'react';
import { Icons } from '../ui';
import logofull from '../../media/images/logofull.png';

const XSocialIcon = Icons.X_social;

const Footer = () => {
  return (
    <footer className="mt-16 border-t border-gray-200 bg-white">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-6 py-8">
        <div className="flex flex-col items-center gap-5">
          <img src={logofull} alt="ImageShield" className="h-8 w-auto" />

          <a
            href="https://www.imageshield.com"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full max-w-[342px] sm:max-w-3xl lg:max-w-5xl min-h-[132px] sm:min-h-0 bg-gray-50 border border-gray-200 rounded-[44px] sm:rounded-[999px] px-5 sm:px-4 py-3 sm:py-2.5 flex flex-col sm:flex-row items-center justify-evenly sm:justify-evenly gap-2 sm:gap-4 text-sm hover:border-brand-200 transition"
          >
            <span className="text-center text-slate-600 sm:w-auto sm:text-left sm:leading-normal">
              <span className="max-sm:hidden text-center">Protect Your Face from Deepfakes, Scams and Other Abuses</span>
              <span className="block text-[13px] font-medium leading-[18px] sm:hidden">
                Protect Your Face from Deepfakes,
                <br />
                Scams and Other Abuses
              </span>
            </span>
            <span className="inline-flex h-6 min-w-[72px] shrink-0 items-center justify-center rounded-md bg-brand-600 px-3 text-[11px] font-bold leading-none tracking-widest text-white whitespace-nowrap sm:h-auto sm:min-w-0 sm:px-3 sm:py-1.5 sm:text-xs">
              STEVIE
            </span>
          </a>

          <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-xs text-slate-500">
            <span>&copy;2026 ImageShield LLC. All rights reserved.</span>
            <span className="text-slate-300">|</span>
            <span>Fairfax, VA</span>
            <span className="text-slate-300">|</span>
            <a className="text-brand-600 hover:underline" href="mailto:support@imageshield.com">
              Contact
            </a>
            <span className="text-slate-300">|</span>
            <a
              className="text-brand-600 hover:underline"
              href="https://www.imageshield.com/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              Our Privacy Policy
            </a>
            <span className="text-slate-300">|</span>
            <a
              className="text-brand-600 hover:underline"
              href="https://www.imageshield.com/About"
              target="_blank"
              rel="noopener noreferrer"
            >
              About Us
            </a>
          </div>

          <div className="flex items-center gap-4 text-slate-500">
            <a
              href="https://www.facebook.com/people/ImageShield/100064076020962/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-brand-600"
              aria-label="Facebook"
            >
              <Icons.Facebook className="w-4 h-4" />
            </a>
            <a
              href="https://www.instagram.com/image_shield/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-brand-600"
              aria-label="Instagram"
            >
              <Icons.Instagram className="w-4 h-4" />
            </a>
            <a
              href="https://x.com/image_shield"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-brand-600"
              aria-label="X"
            >
              <XSocialIcon className="w-4 h-4" />
            </a>
            <a
              href="https://www.linkedin.com/company/imageshield-protection"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-brand-600"
              aria-label="LinkedIn"
            >
              <Icons.LinkedIn className="w-4 h-4" />
            </a>
            <a
              href="https://www.youtube.com/@UseImageShield"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-brand-600"
              aria-label="YouTube"
            >
              <Icons.Youtube className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
